import Collapse from '@material-ui/core/Collapse';

import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from '../../assets/jss/sideNavigationStyle';
import { hideOtherSubMenu, manageIcon } from '../../helper/NavigationMenu';

class ExpendedMenuBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: false,
    };
    this.activeTab = '';
    this.activeSubTab = '';
  }

  componentDidUpdate() {
    const path = window.location.pathname;
    const { menuItems = [] } = this.props;
    menuItems.map((menu) => {
      if (menu.path && menu.path.split('/').join('') === path.split('/').join('')) {
        this.activeSubTab = menu.module;
        this.activeTab = menu.module;
      } else if (menu.children) {
        menu.children.map((submenu) => {
          if (submenu.path && (submenu.path === path || (`${submenu.path}/`) === path)) {
            this.activeSubTab = submenu.module;
            this.activeTab = menu.module;
          }
          return true;
        });
      }
      return true;
    });
  }

  /*
   * function to sets the current state of a menu item
   * i.e whether it is in expanded or collapsed or a collapsed state
   * */
  handleClick(item) {
    const { state } = this;
    const newState = hideOtherSubMenu(item, state[item]);
    this.setState(newState);
  }

  /**
   * function to check and update for current active menu
   * @param item
   */
  checkActiveMenu = (item) => {
    this.activeTab = item;
    const { onMenuSelect } = this.props;
    onMenuSelect(item);
  };

  checkActiveSubMenu = (item) => {
    const { onMenuSelect } = this.props;
    const { flag } = this.props;
    this.activeSubTab = item;
    this.activeTab = item;
    this.setState({ flag: !flag });
    onMenuSelect(item);
  };

  /*
   * function to handle menu , if the menu item doesn't have any child,
   * this method simply returns a clickable menu item that redirects to any location
   * and if there is no child this method uses recursion to go until the last level of
   * children and then returns the item by the first condition.
   * */
  menuHandler(children) {
    const {
      classes,
      menuList,
      defaultSelectedMenu,
    } = this.props;
    const { state } = this;

    if (children) {
      return children.map((subOption) => {
        if (menuList.indexOf(subOption.module) > -1) {
          if (!this.activeTab) {
            this.activeTab = defaultSelectedMenu;
          }
          if (!subOption.children) {
            return (
              <div
                aria-hidden="true"
                key={subOption.title}
                onClick={() => this.checkActiveSubMenu(subOption.module)}
              >
                <Link
                  to={{
                    pathname: subOption.path,
                    state: {
                      permission: menuList,
                    },
                  }}
                  className={`${classes.links}  ${subOption.isSubMenu ? classes.subMenu : ''} `}
                >
                  <ListItem
                    className={`${classes.menuColors}  ${subOption.isSubMenu ? classes.subMenuList : ''} 
                    
                    ${(this.activeTab === subOption.module) ? classes.activeMenu : ''} 
                    ${(subOption.isSubMenu && this.activeSubTab === subOption.module) ? classes.selectedSubMenuTextColor : ''}`}
                    button
                    selected={this.activeTab === subOption.module}
                    key={subOption.title}
                  >
                    {!subOption.icon ? '' : manageIcon(subOption.icon)}
                    <span className={classes.menuBorder} id="activei" />
                    <ListItemText inset>
                      <span
                        className={`${(subOption.isSubMenu && this.activeSubTab === subOption.module) ? classes.selectedSubMenuTextColor : ''}`}
                      >
                        <Trans i18nKey={subOption.title} />
                      </span>
                    </ListItemText>
                    <span className={classes.navBorderBottom} />
                  </ListItem>

                </Link>

              </div>
            );
          }
          return (
            <div
              aria-hidden="true"
              key={subOption.title}
              onClick={() => this.checkActiveMenu(subOption.module)}
              className={classes.dropdownMenu}
            >
              <ListItem
                className={`${classes.menuColors}  ${(state[subOption.title]) ? classes.menuColorDropdown : ''}`}
                button
                selected={this.activeTab === subOption.module}
                onClick={() => this.handleClick(subOption.title)}
              >
                {!subOption.icon ? '' : manageIcon(subOption.icon)}

                <span className={classes.menuBorder} id="activeSubIcon" />
                <ListItemText inset>
                  <span><Trans i18nKey={`${subOption.title}`} /></span>
                </ListItemText>
                {state[subOption.title] ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={state[subOption.title]} timeout="auto" unmountOnExit>
                {this.menuHandler(subOption.children)}
              </Collapse>
            </div>
          );
        }
        return '';
      });
    }
  }

  render() {
    const { classes, menuItems } = this.props;

    return (
      <div className={classes.list}>
        <Drawer variant="persistent" anchor="left" open classes={{ paper: classes.list }}>
          <div className={classes.removePadding}>
            <List className={classes.removePadding}>{this.menuHandler(menuItems)}</List>
          </div>
        </Drawer>
      </div>
    );
  }
}

const stylesheets = withStyles(styles, { withTheme: true })(ExpendedMenuBar);
export default withTranslation()(stylesheets);
